import { render, staticRenderFns } from "./PopupNotifications.vue?vue&type=template&id=6da10913&scoped=true"
import script from "./PopupNotifications.vue?vue&type=script&lang=js"
export * from "./PopupNotifications.vue?vue&type=script&lang=js"
import style0 from "./PopupNotifications.vue?vue&type=style&index=0&id=6da10913&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da10913",
  null
  
)

export default component.exports